module.exports = __webpack_public_path__ + "static/media/tear_through.8196980e.svg";